<template>
    <div>
        <template v-for="(tracker, index) in trackers">
            <tracker :tracker="tracker" :highlighted="highlighted[index] ? true : false" :selected="selected[index] ? true : false" :contextmenu="contextMenu[index]"
                :trackerStatus="status[`${tracker.gcu_code}_${tracker.lcu_code}`]" :infoActive="infoActive" :angle="angle"
                @mouseover="handleMouseOver" @mouseout="handleMouseOut" @click="handleClick" @contextmenu="handleContextMenu" :key="`${tracker.gcu_code}_${tracker.lcu_code}`">
            </tracker>
        </template>
    </div>
</template>

<script>
import Tracker from './Tracker';
import { mapGetters } from 'vuex';

export default {
    name: 'Subarray',
    components: {
        Tracker
    },
    props: {
        trackers: {
            type: Array
        },
        toggleMode: {
            type: String,
            default: 'Single'
        },
        selectedTrackers: {
            type: Object,
            default: null
        },
        infoActive: {
            type: Boolean,
            default: false
        },
        action: {
            type: String,
            default: null
        },
        angle: {
            type: Number,
            default: 0
        },
        currentContextMenu: {
            type: Object
        },
        panning: {
          type: Boolean,
          default: false
        }
    },
    data() {
        return {
            currentMouseOverTracker: null
        }
    },
    computed: {
      ...mapGetters('savanna/trackers', {
        trackerStatus: 'getTrackerStatus'
      }),
      status() {
        let status = {};

        const gcuCode = this.trackers[0].gcu_code;
        this.trackerStatus(gcuCode).forEach((tracker) => {
          const key = `${tracker.gcuCode}_${tracker.lcuCode}`;
          Object.assign(status, { [key] : tracker });
        });

        return status;
      },
      highlighted() {
        const highlighted = [];

        if (this.panning) return highlighted;

        this.trackers.forEach((tracker) => {
          if (!this.currentMouseOverTracker) {
            highlighted.push(false);
          } else {
            const [currCol, currRow] = this.currentMouseOverTracker;

            switch (this.toggleMode) {
              case 'Single':
                highlighted.push(tracker.col === currCol && tracker.row === currRow);
                break;
              case 'Column':
                highlighted.push(tracker.col === currCol);
                break;
              case 'Row':
                highlighted.push(tracker.row === currRow);
                break;
              case 'Subarray':
                highlighted.push(true);
                break;
              default:
                highlighted.push(false);
            }
          }
        });

        return highlighted;
      },
      selected() {
        const selected = [];

        this.trackers.forEach((tracker) => {
          const trackerKey = `${tracker.gcu_code}_${tracker.lcu_code}`;
          if (this.selectedTrackers && this.selectedTrackers[trackerKey]) selected.push(true);
          else selected.push(false);
        });

        return selected;
      },
      contextMenu() {
        const contextmenu = [];

        this.trackers.forEach((tracker) => {
          if(!this.currentContextMenu) {
            contextmenu.push({ show: false });
          } else {
            let { gcu_code, lcu_code, pos } = this.currentContextMenu;
            contextmenu.push({ show: tracker.gcu_code === gcu_code && tracker.lcu_code === lcu_code, pos});
          }
        });

        return contextmenu;
      }
    },
    methods: {
        handleMouseOver(selectedTracker) {
            this.currentMouseOverTracker = [selectedTracker.col, selectedTracker.row];
            return;
        },
        handleMouseOut() {
            this.currentMouseOverTracker = null;
            return;
        },
        handleClick(ctrlKey, selectedTracker) {
            const { toggleMode } = this;

            let selectedTrackers = {};
            let isCtrlKey = false;
            if (ctrlKey) {
                isCtrlKey = true;
                // this.selectedTrackers are the trackers selected before the one that was clicked, so if ctrl was held
                // then we want to include them in the selectedTrackers, otherwise we will only include the ones that were clicked
                Object.assign(selectedTrackers, this.selectedTrackers);
            }

            switch (this.toggleMode) {
                case 'Single':
                    const trackerKey = `${selectedTracker.gcu_code}_${selectedTracker.lcu_code}`;
                    if (!selectedTrackers[trackerKey]) {
                        selectedTrackers[trackerKey] = selectedTracker;
                    }
                    break;
                case 'Column':
                    const colTrackers = this.trackers.filter((tracker) => tracker.col === selectedTracker.col);
                    colTrackers.forEach((tracker) => {
                        const trackerKey = `${tracker.gcu_code}_${tracker.lcu_code}`;
                        if (!selectedTrackers[trackerKey]) {
                            selectedTrackers[trackerKey] = tracker;
                        }
                    });
                    break;
                case 'Row':
                    const rowTrackers = this.trackers.filter((tracker) => tracker.row === selectedTracker.row);
                    rowTrackers.forEach((tracker) => {
                        const trackerKey = `${tracker.gcu_code}_${tracker.lcu_code}`;
                        if (!selectedTrackers[trackerKey]) {
                            selectedTrackers[trackerKey] = tracker;
                        }
                    });
                    break;
                case 'Subarray':
                    selectedTrackers = this.trackers.reduce((acc, tracker) => {
                        const trackerKey = `${tracker.gcu_code}_${tracker.lcu_code}`;
                        acc[trackerKey] = tracker;
                        return acc;
                    }, {});
                    break;
                default:
                    // Do nothing
            }

            this.$emit('click', selectedTrackers, isCtrlKey);
        },
        handleContextMenu(tracker) {
            this.$emit('contextmenu', tracker);
        }
    },
    watch: {
        action() {
            if (this.action === 'Select All') {
                const selectedTrackers = this.trackers.reduce((acc, tracker) => {
                    const trackerKey = `${tracker.gcu_code}_${tracker.lcu_code}`;
                    acc[trackerKey] = tracker;
                    return acc;
                }, {});
                this.$emit('click', selectedTrackers);
            } else if (this.action === 'Deselect All') {
                const selectedTrackers = {};
                this.$emit('click', selectedTrackers);
            }
        }
    }
}
</script>
